import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function NavBar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="tech-divider sticky top-0 z-30 bg-white" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-7 h-7 bg-black grid place-items-center">
            <div className="w-2.5 h-2.5 bg-white" />
          </div>
          <span className="font-display font-black tracking-tight uppercase text-lg">
            HW/Engineering<span style={{ color: "var(--c-primary)" }}>.</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 ribbon">
          <a href="/#services" data-testid="nav-link-services">Services</a>
          <a href="/#how" data-testid="nav-link-how">How it works</a>
          <a href="/#pricing" data-testid="nav-link-pricing">Pricing</a>
          <a href="/#faq" data-testid="nav-link-faq">FAQ</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="btn btn-sm btn-outline" data-testid="nav-admin-link">Admin</Link>
              )}
              <Link to="/dashboard" className="btn btn-sm btn-outline" data-testid="nav-dashboard-link">Dashboard</Link>
              <button className="btn btn-sm" onClick={() => { logout(); nav("/"); }} data-testid="nav-logout-btn">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-sm btn-outline" data-testid="nav-login-link">Login</Link>
              <Link to="/signup" className="btn btn-sm btn-primary" data-testid="nav-signup-link">Get Started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
